
<div class="page-error-container" nz-flex nzJustify="center" nzAlign="center" nzVertical>
	<nz-icon nzType="tool" nzTheme="outline" />
	<h2>{{'ERRORS.NOT-WORKING' | translate}}</h2>
	<p>{{'ERRORS.LATER' | translate}}</p>
</div>
